const Joi = require("joi");

const eCardCategorySchema = (data) => {
  const schema = Joi.object({
    categoryName: Joi.string().required().max(50).messages({
      "string.empty": "Please enter Category Name.",
      "string.max": "Max length is 50.",
      "any.required": "Please enter Category Name.",
    }),

    fromMonth: Joi.number()
      .valid(1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12)
      .required()
      .messages({
        "any.only": "Please select Start Month.",
        "any.required": "Please select Start Month.",
      }),

    toMonth: Joi.number()
      .valid(1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12)
      .required()
      .messages({
        "any.only": "Please select End Month.",
        "any.required": "Please select End Month.",
      }),

    costCategory: Joi.alternatives()
      .try(Joi.valid(0), Joi.number().positive().precision(2).min(0.05).max(99))
      .messages({
        "number.base": "Please enter Cost.",
        "alternatives.match": "Please enter a value between 0.05 and 99.",
        "number.positive": "Please enter a value between 0.05 and 99.",
        "number.precision":
          "Please enter a value with up to two decimal places.",
        "number.min": "Please enter a value between 0.05 and 99.",
        "number.max": "Please enter a value between 0.05 and 99.",
      }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  });
};

const eCardSchema = (data) => {
  const schema = Joi.object({
    ecardName: Joi.string().required().max(50).messages({
      "string.empty": "Please enter E-Card Name.",
      "string.max": "Max length is 50.",
      "any.required": "Please enter E-Card Name.",
    }),

    categoryId: Joi.number().required().greater(0).messages({
      "any.required": "Please select Category.",
      "number.greater": "Please select Category.",
      "number.base": "Please select Category.",
    }),

    ecardImage: Joi.object({
      name: Joi.string().messages({
        "string.base": "Image name must be a string.",
      }),

      type: Joi.string()
        .valid("image/jpeg", "image/png", "image/jpg")
        .required()
        .messages({
          "string.base": "Please upload E-Card.",
          "any.only": "Please upload a valid image file (JPEG/PNG/JPG).",
          "any.required": "Please upload E-Card.",
        }),

      size: Joi.number().messages({
        "number.base": "Please ensure the image size is a number.",
        "number.max": "File size should not exceed 2MB.",
      }),
    })
      .custom((value, helpers) => {
        const { type, size } = value;
        // Only check size if the type is valid
        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
        if (allowedTypes.includes(type)) {
          if (typeof size !== "number") {
            return helpers.message("Image size must be a number.");
          }
          if (size > 2 * 1024 * 1024) {
            return helpers.message("File size should not exceed 2MB.");
          }
        }
        return value;
      }, "Conditional size validation")
      .required()
      .messages({
        "any.required": "Please upload E-Card.",
      }),

    isActive: Joi.number().valid(1, 0).required().messages({
      "any.only": "Please choose Active Status.",
      "any.required": "Please choose Active Status.",
    }),

    visibleTo: Joi.number().valid(1, 2, 3).required().messages({
      "any.only": "Please choose visibleTo Status.",
      "any.required": "Please choose visibleTo Status.",
    }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  });
};

module.exports = {
  eCardCategorySchema,
  eCardSchema,
};
